import { Component, OnInit } from '@angular/core';
import { Users, Pictures, Projects, Logs } from 'api/collections';
import { User, Project, Picture, Log } from 'api/models';
import { AlertController, ViewController, NavParams } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { App } from "ionic-angular";

// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { APP_TITLE } from '../../services/config';
import { HttpService } from '../../services/httpService';
import { SharedService } from '../../services/sharedService';


@Component({
  selector: 'add-log-user',
  templateUrl: 'add-log-user.html'
})
export class AddLogUserPage implements OnInit {
  searchPattern: BehaviorSubject < any > ;
  logId: string;
  log ? : Log;
  project: Project | void;
  users: User[];
  usersSubscription: Subscription;
  constructor(
    private _app: App,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    public httpService: HttpService,
    private sharedService: SharedService,
    public projectService: ProjectService
  ) {
    this.searchPattern = new BehaviorSubject(undefined);

    this.logId = <string>navParams.get('logId');
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
  console.log('add log user page');
    const autorun = MeteorObservable.autorun();

    // const subscription = MeteorObservable.subscribe('logDetails', this.logId);
    const subscription = this.httpService.MeteorSubscribe('logDetails', this.logId);
    this.httpService.privateLoopAction(true).then(()=>{
      Observable.merge(this.observeSearchBar(), subscription, autorun).subscribe(() => {
        this.log = Logs.findOne(this.logId);
        if (this.log) {
          this.project = this.projectService.getProject(this.log.projectId);
        }
        this.users = this.findUsers();
      });

    });
  }

  updateSubscription(newValue) {
    this.searchPattern.next(newValue);
  }

  observeSearchBar(): Observable<any> {
    return this.searchPattern.asObservable().debounce(() => Observable.timer(400));
  }

  findUsers(): User[] {
    if (!this.project || !this.log) {
      return [];
    }

    const { updaterIds, pmIds } = this.project;
    const { additionalUserIds } = this.log;
    const searchPattern = this.searchPattern.getValue();
    const query = {
      _id: {
        $in: updaterIds || [], // you can only add project updaters
        $nin: [
          ...(additionalUserIds || []),
          ...(pmIds || []),
        ], // exclude members already added to the log
      },
    };
    if (searchPattern) {
      query['profile.name'] = { $regex: searchPattern, $options: 'i' };
    }
    return Users.find(query).fetch();
  }


  addLogUser(user): void {
    /*
    MeteorObservable.call('addLogUser', this.logId, user._id).subscribe({
      next: () => {
        this.viewCtrl.dismiss();
      },
      error: (e: Error) => {
        this.viewCtrl.dismiss().then(() => {
          this.showError(e);
        });
      }
    });
    */

    this.httpService.MeteorCall(
      'addLogUser',
      this.logId,
      user._id
    ).then(() => {
      this.viewCtrl.dismiss();
    })
    .catch((e: Error) => {
      this.viewCtrl.dismiss().then(() => {
        this.showError(e);
      });
    });
  }

  showError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/add-log-user/add-log-user.ts